import React, { Component } from 'react';
import Card from '../../../CardNew';
import { PREMIUM } from '../../constants';
import GeneralRibbonUtils from '../../GeneralRibbonUtils';
import './styles.css';
class RibbonPremium extends Component {
  constructor(props) {
    super(props);
    this.carruselTitle = props.carruselTitle;
    this.items = props.items;
    this.visibleItems = props.visibleItems;
    this.badgesUserType = props.badgesUserType;
    this.ignoreSeenLast = props.ignoreSeenLast;
    this.focusSettings = props.focusSettings;
    this.ribbonId = props.ribbonId;
    this.focusHandler = props.focusHandler;
    this.onClickHandler = props.onClickHandler;
    this.setMetricsEvent = props.setMetricsEvent;
    this.hideInnerTitle = props.hideInnerTitle;
    this.keyDownHandler = props.keyDownHandler;
    this.className = props.className;
    this.title = props.title;
    this.ribbonIndex = props.index;
    this.typeRender = props.typeRender ? props.typeRender : null;
    this.dataUpdateMetrics = props.dataUpdateMetrics;
    this.ribbonName = props.ribbonName;
    this.device = props.device;
    this.idsRibbonsUpAndDown = props.idsRibbonsUpAndDown;

  }

  clickHandler(data) {
    this.onClickHandler && this.onClickHandler(data);
  }

    getMetricsTitle(item) {
        const source = [item.href, item.src].find(value => typeof value === 'string' && value.length > 0);
        return source ? source.split('/').pop() : '';
    }

    updateMetricsSafely(data) {
        try { this.dataUpdateMetrics && this.dataUpdateMetrics(data); }
        catch (error) { console.error('[RibbonPremium] Metrics update failed', error); }
    }

  resolveCardType(item) {
    let isLiveTV = false;
    if (item.type && item.type == 'live') {
      if (item.live_enabled && item.live_enabled == 1) {
        isLiveTV = true;
      }
    }

    return isLiveTV ? 'a' : '';
  }

    render() {
        return (
            <div className="ribbon-items ribbon-premium">
                {this.visibleItems.map((node, index) => {
                    const node_item = node.item;
                    const badges = GeneralRibbonUtils.getBadgesHTML(this.badgesUserType, node_item);
                    const key = `${this.ribbonId}-${node_item.group_id || node_item.id}-pos-${index}`;
                    const uri = node_item.src;
                    const cardType = this.resolveCardType(node_item);
                    const dataMetricsRibbon = {
                        node_item: { title: this.getMetricsTitle(node_item) },
                        node_location: window.location.pathname,
                        ribbon_title: this.carruselTitle || this.ribbonId,
                    };

                    const existImage = node_item
                      && node_item.image_highlight
                      && node_item.image_highlight !== '';
                    const isResized = existImage
                      && (node_item.image_highlight.includes("?size") || node_item.image_highlight.includes("resize"));
                    const applyResize = existImage ? GeneralRibbonUtils.resizeImage(node_item.image_highlight, [400, 0]) : "";

                    const coverResize = isResized
                        ? node_item.image_highlight
                        : applyResize;

                    const cardProps = {
                        ribbonLength: this.visibleItems.length,
                        unFocusHandler: this.unFocusHandler,
                        id: index + 1,
                        key: key,
                        ribbonIndex: this.ribbonIndex,
                        ignoreSeenLast: this.ignoreSeenLast,
                        data: node_item,
                        group_id: node_item.group_id || node_item.id,
                        cover: coverResize,
                        hideTitles: this.props.hideTitles,
                        label: node_item.label,
                        type: PREMIUM,
                        title: node_item.title,
                        badgesHtml: badges,
                        typeRender: this.resolveCardType(node_item),
                        dataMetric: {
                            carruselTitle: this.carruselTitle,
                            cardPosition: GeneralRibbonUtils.getPosition(
                                this.items,
                                node_item.title
                            ),
                        },
                        focusable: true,
                        focusRight: `#${this.ribbonId} ${this.focusSettings.selector}`,
                        focusLeft: `#${this.ribbonId} ${this.focusSettings.selector}`,
                        focusHandler: this.focusHandler,
                        setMetricsEvent: this.setMetricsEvent,
                        href: uri,
                        hideInnerTitle: this.hideInnerTitle,
                        bookmark: node_item.bookmark ? String(node_item.bookmark) : '0',
                        filterTV: node_item.filterTV ? node_item.filterTV : null,
                        ribbonName : this.ribbonName,
                        ribbonId: this.ribbonId,
                        onClick:
                            cardType === 'a'
                                ? (e) => {
                                      this.updateMetricsSafely(dataMetricsRibbon);
                                      e.preventDefault();
                                      e.stopPropagation();
                                      this.clickHandler(node_item);
                                  }
                                : () => {
                                      this.updateMetricsSafely(dataMetricsRibbon);
                                  },
                      idsRibbonsUpAndDown: this.idsRibbonsUpAndDown
                    };
                    return <Card {...cardProps} />;
                })}
            </div>
        );
    }
}

export default RibbonPremium;



// WEBPACK FOOTER //
// ./src/components/RibbonNew/RibbonTypes/RibbonPremium/index.jsx